module.exports = __webpack_public_path__ + "static/media/IMG_2415.1f0c79ca.jpg";